import { CrudMode } from '@ohpen/enso-ui';
import { ChangeRequestsAction, ChangeRequestsState } from './interfaces';

const initialCrudState = {
  record: null,
  entityType: null,
  isOpen: false,
  isLoading: false,
  data: null,
  originalData: null,
  reviewInfo: null,
  mode: CrudMode.VIEW,
  validationFeedback: null,
};

export const initialState: ChangeRequestsState = {
  deleteModal: { open: false, record: null },
  applyModal: { open: false, record: null },
  crudTable: { ...initialCrudState },
  isLoading: false,
  dataSource: [],
  entitiesAdditionalFields: null,
};

export function reducer(prevState: ChangeRequestsState, action: ChangeRequestsAction): ChangeRequestsState {
  switch (action.type) {
    case 'setDataSource':
      if (!action.dataSource) throw new Error(`Invalid action provided ${action.type}`);
      return { ...prevState, dataSource: action.dataSource };
    case 'updateDataSource':
      if (!action.dataSourceRow) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...prevState,
        dataSource: prevState.dataSource.map(row =>
          row.actionId === action.dataSourceRow?.actionId ? { ...row, ...action.dataSourceRow } : row,
        ),
      };
    case 'setIsLoading':
      return { ...prevState, isLoading: action.isLoading ?? false };
    case 'setEntityAdditionalFields':
      if (!action.entityAdditionalFields || !action.entityType) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...prevState,
        entitiesAdditionalFields: { ...prevState.entitiesAdditionalFields, [action.entityType]: action.entityAdditionalFields },
      };
    case 'openCrudTable':
      if (!action.crudTable) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...prevState,
        crudTable: {
          ...prevState.crudTable,
          ...action.crudTable,
          isOpen: true,
        },
      };
    case 'closeCrudTable':
      return {
        ...prevState,
        crudTable: { ...initialState.crudTable },
      };
    case 'openDeleteModal':
      if (!action.record) throw new Error(`Invalid action provided ${action.type}`);
      return { ...prevState, deleteModal: { open: true, record: action.record } };
    case 'closeDeleteModal':
      return { ...prevState, deleteModal: { open: false, record: null } };
    case 'openApplyModal':
      if (!action.record) throw new Error(`Invalid action provided ${action.type}`);
      return { ...prevState, applyModal: { open: true, record: action.record } };
    case 'closeApplyModal':
      return { ...prevState, applyModal: { open: false, record: null } };
    default:
      throw new Error(`No action provided ${action.type}`);
  }
}
